import { render, staticRenderFns } from "./Keypad.vue?vue&type=template&id=b8b3baf8&scoped=true&"
import script from "./Keypad.vue?vue&type=script&lang=js&"
export * from "./Keypad.vue?vue&type=script&lang=js&"
import style0 from "./Keypad.vue?vue&type=style&index=0&id=b8b3baf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b3baf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
